'use client';

import { Card } from '@app/app/_components/Card/Card';
import { VehicleInformation } from '@app/domain/model/eshop/transport/VehicleInformation';
import { FormState } from '@app/lib/form/contracts/FormState';
import { DiscountCodeData } from '@app/domain/model/eshop/transport/DiscountCodeData';
import { PurchaseTransportInsuranceResult } from '@app/service/eshop/transport/actions/purchaseTransportInsurance';
import { ProductDataLeasing } from '@app/domain/model/eshop/transport/ProductDataLeasing';
import { ProductDataTerritories } from '@app/domain/model/eshop/transport/ProductDataTerritories';
import { ProductDataCriterion } from '@app/domain/model/eshop/transport/ProductDataCriterion';
import { VehicleInformationPanel } from '@app/app/esales/transport/_sections/steps/VehicleInformationStep/VehicleInformationPanel';
import { DrivingExperiencePanel } from '@app/app/esales/transport/_sections/steps/VehicleInformationStep/DrivingExperiencePanel';
import { OtherDriversPanel } from '@app/app/esales/transport/_sections/steps/VehicleInformationStep/OtherDriversPanel';
import { LeasingPanel } from '@app/app/esales/transport/_sections/steps/VehicleInformationStep/LeasingPanel';
import { TerritoryPanel } from '@app/app/esales/transport/_sections/steps/VehicleInformationStep/TerritoryPanel';

interface Props {
    vehicleInformation: VehicleInformation;
    formState: FormState<PurchaseTransportInsuranceResult>;
    criterions: ProductDataCriterion[];
    handleDiscountCode: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleApplyDiscountClick: () => void;
    discountCodeData: DiscountCodeData;
    isCompany: boolean;
    ownerYear?: number;
    isCascoPresent: boolean;
    cascoLeasings: ProductDataLeasing[];
    mtplTerritories: Nullable<ProductDataTerritories>;
}

export function VehicleInformationStep({
    vehicleInformation,
    formState,
    criterions,
    isCompany,
    ownerYear,
    isCascoPresent,
    cascoLeasings,
    mtplTerritories,
}: Props) {
    return (
        <div className="flex flex-col gap-8">
            <Card className="gap-6 p-6">
                <VehicleInformationPanel vehicleInformation={vehicleInformation} formState={formState} />

                {!isCompany && <DrivingExperiencePanel ownerYear={ownerYear} formState={formState} />}

                <OtherDriversPanel criterions={criterions || []} formState={formState} isCompany={isCompany} />

                {isCascoPresent && cascoLeasings && cascoLeasings.length > 0 && (
                    <LeasingPanel cascoLeasings={cascoLeasings} formState={formState} />
                )}

                {mtplTerritories && mtplTerritories.territories.length > 0 && (
                    <TerritoryPanel mtplTerritories={mtplTerritories} formState={formState} />
                )}
            </Card>
        </div>
    );
}
